import React, { useState, useEffect } from "react";
import FacultyNavbar from './FacultyNavbar';
import '../styles/Faculty.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faComments, faEnvelope, faCalendarCheck, faTachometerAlt } from '@fortawesome/free-solid-svg-icons';
import MessageComponent from './MessageComponent';
import Timetable from './Timetable';
import FacultyDashboard from "./FacultyDashboard";
import AssignTrainers from "./AssignTrainers"; // Import AssignTrainers

const Faculty = () => {
  const [allRows, setAllRows] = useState([]);
  const [activeSection, setActiveSection] = useState("Dashboard");
  const [groupStudents, setGroupStudents] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [timetableStatus, setTimetableStatus] = useState({
    Excellent: false,
    Capable: false,
    Idle: false,
  });
  const [showAssignTrainers, setShowAssignTrainers] = useState(false); // State to show/hide AssignTrainers
  const [assignedTrainers, setAssignedTrainers] = useState([]); // State to store assigned trainers

  useEffect(() => {
    fetch("https://backend-main-4.onrender.com/data")
      .then((response) => response.json())
      .then((rows) => setAllRows(rows));

    // Check if timetables exist for each group
    ["Excellent", "Capable", "Idle"].forEach(async (group) => {
      try {
        const response = await fetch(`https://backend-main-4.onrender.com/fetch-timetable?group=${group}`);
        if (response.ok) {
          const data = await response.json();
          if (Object.keys(data).length > 0) {
            setTimetableStatus(prevStatus => ({ ...prevStatus, [group]: true }));
          }
        }
      } catch (error) {
        console.error(`Error fetching timetable for ${group}:`, error);
      }
    });
  }, []);

  const handleGroupClick = (group) => {
    setActiveSection(group);
    setSelectedGroup(group);
    let filteredStudents = [];

    if (group === "Excellent") {
      filteredStudents = allRows.filter(row => {
        const html = parseFloat(row[10]);
        const css = parseFloat(row[11]);
        const js = parseFloat(row[12]);
        const average = (html + css + js) / 3;
        return average > 50 && parseFloat(row[6]) > 60 && parseFloat(row[7]) > 60 && parseFloat(row[8]) > 60;
      });
    } else if (group === "Capable") {
      filteredStudents = allRows.filter(row => {
        const html = parseFloat(row[10]);
        const css = parseFloat(row[11]);
        const js = parseFloat(row[12]);
        const average = (html + css + js) / 3;
        return average <= 50 && parseFloat(row[6]) > 60 && parseFloat(row[7]) > 60 && parseFloat(row[8]) > 60;
      });
    } else if (group === "Idle") {
      filteredStudents = allRows.filter(row => parseFloat(row[6]) <= 60 || parseFloat(row[7]) <= 60 || parseFloat(row[8]) <= 60);
    }

    setGroupStudents(filteredStudents);

    // Fetch assigned trainers for the group
    fetch(`http://localhost:3009/api/assigned-trainers?group=${group}`)
      .then(response => response.json())
      .then(data => setAssignedTrainers(data))
      .catch(error => console.error('Error fetching assigned trainers:', error));
  };

  const handleDeleteTimetable = async (group) => {
    try {
      const response = await fetch("https://backend-main-4.onrender.com/delete-timetable", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ group }),
      });

      if (response.ok) {
        setTimetableStatus(prevStatus => ({ ...prevStatus, [group]: false }));
        alert("Timetable deleted successfully!");
      } else {
        throw new Error("Failed to delete timetable.");
      }
    } catch (error) {
      console.error(`Error deleting timetable for ${group}:`, error);
    }
  };

  return (
    <>
      <FacultyNavbar />
      <div className="faculty-container">
        <div className="sidebar">
          <ul>
            <li onClick={() => setActiveSection("Dashboard")}>
              <FontAwesomeIcon icon={faTachometerAlt} title="Dashboard" />
            </li>
            <li onClick={() => setActiveSection("Groups")}>
              <FontAwesomeIcon icon={faUsers} title="Groups" />
            </li>
            <li onClick={() => setActiveSection("Feedback")}>
              <FontAwesomeIcon icon={faComments} title="Feedback" />
            </li>
            <li onClick={() => setActiveSection("Messages")}>
              <FontAwesomeIcon icon={faEnvelope} title="Messages" />
            </li>
            <li onClick={() => setActiveSection("Attendance")}>
              <FontAwesomeIcon icon={faCalendarCheck} title="Attendance" />
            </li>
          </ul>
        </div>
        <div className="content">
          {activeSection === "Dashboard" && <FacultyDashboard />}





          {activeSection === "Groups" && (
            <div className="group-selection">
              <h3>Select a Group</h3>
              <div className="group-row">
                <div className="group-box" onClick={() => handleGroupClick("Excellent")}>
                  <h4>Excellent Group</h4>
                  <p>Students with average marks above 50% in HTML, CSS, and JavaScript</p>
                  {timetableStatus.Excellent ? (
                    <>
                      <p className="timetable-status">Your timetable is created</p>
                      <button onClick={() => setActiveSection("Timetable")}>View Timetable</button>
                      <button onClick={() => handleDeleteTimetable("Excellent")}>Delete Timetable</button>
                    </>
                  ) : (
                    <button onClick={() => setActiveSection("Timetable")} className="create-timetable-button">
                      Create Timetable
                    </button>
                  )}
                </div>
                <div className="group-box" onClick={() => handleGroupClick("Capable")}>
                  <h4>Capable Group</h4>
                  <p>Students with average marks below 50% in HTML, CSS, and JavaScript</p>
                  {timetableStatus.Capable ? (
                    <>
                      <p className="timetable-status">Your timetable is created</p>
                      <button onClick={() => setActiveSection("Timetable")}>View Timetable</button>
                      <button onClick={() => handleDeleteTimetable("Capable")}>Delete Timetable</button>
                    </>
                  ) : (
                    <button onClick={() => setActiveSection("Timetable")} className="create-timetable-button">
                      Create Timetable
                    </button>
                  )}
                </div>
                <div className="group-box" onClick={() => handleGroupClick("Idle")}>
                  <h4>Idle Group</h4>
                  <p>Students who are not eligible</p>
                  {timetableStatus.Idle ? (
                    <>
                      <p className="timetable-status">Your timetable is created</p>
                      <button onClick={() => setActiveSection("Timetable")}>View Timetable</button>
                      <button onClick={() => handleDeleteTimetable("Idle")}>Delete Timetable</button>
                    </>
                  ) : (
                    <button onClick={() => setActiveSection("Timetable")} className="create-timetable-button">
                      Create Timetable
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {["Excellent", "Capable", "Idle"].includes(activeSection) && (
            <>
              <h3>{activeSection} Group</h3>
              {timetableStatus[selectedGroup] && (
                <Timetable group={selectedGroup} />
              )}
              <button onClick={() => setShowAssignTrainers(true)} className="assign-trainers-button">
                Assign Trainers
              </button><br/>
              {showAssignTrainers && (
                <AssignTrainers
                  group={selectedGroup}
                  onClose={() => setShowAssignTrainers(false)}
                />
              )}
                <h4>Assigned Trainers</h4>
              {assignedTrainers.length > 0 ? (
                
                <table className="trainers-table">
                  <thead>
                    <tr>
                      <th>Subject</th><th>Trainer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignedTrainers.map((assignment, index) => (
                      <tr key={index}>
                        <td>{assignment.subject}</td><td>{assignment.trainer}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>No trainers assigned yet.</p>
              )}
              <h4>Student Details</h4>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th><th>Roll Number</th><th>Department</th><th>Class</th>



                  </tr>
                </thead>
                <tbody>
                  {groupStudents.map((row, index) => (
                    <tr key={index}>
                      <td>{row[1]}</td><td>{row[0]}</td><td>{row[5]}</td><td>{row[4]}</td>



                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {activeSection === "Messages" && <MessageComponent allRows={allRows} />}
          {activeSection === "Timetable" && <Timetable group={selectedGroup} />}
        </div>
      </div>
    </>
  );
};

export default Faculty;